import React from 'react';

import classnames from 'classnames';

const DockBarButton = ({ type = 'default', action, isHpa, icon, children }) => {
  let buttonClassnames = classnames(
    'ot-dockbar__button',
    `ot-dockbar__button--${type}`
  );
  return (
    <button onClick={() => action()} className={buttonClassnames}>
      <div className="ot-dockbar__button__column" aria-hidden="true">
        {icon}
      </div>
      <div className="ot-dockbar__button__column">{children}</div>
    </button>
  );
};

export default DockBarButton;
